/** An `@query` being typed in the prompt bar: where its `@` sits and what follows it. */
export interface ActiveMention {
  /** Index of the `@` in the text. */
  start: number
  query: string
}

/**
 * The `@mention` the caret is in, if any: an `@` at the start of the text or after whitespace,
 * followed by the characters up to the caret (no whitespace — a space ends the mention, so
 * "@jake buy" is a finished word, not an open picker). An `@` inside a word ("a@b") isn't one.
 */
export function findActiveMention(text: string, caret: number): ActiveMention | null {
  const before = text.slice(0, caret)
  const match = /(^|\s)@([^\s@]*)$/.exec(before)
  if (!match) return null
  return { start: caret - match[2].length - 1, query: match[2] }
}

/** The text with the typed `@query` taken out, and where the caret goes. */
export function removeMention(
  text: string,
  mention: ActiveMention
): { text: string; caret: number } {
  const end = mention.start + 1 + mention.query.length
  // Drop one following space too, so "@jake| buy" doesn't leave a double space behind.
  const rest = text.slice(end).replace(/^ /, '')
  const head = text.slice(0, mention.start)
  return { text: head + rest, caret: head.length }
}
